<template>
  <v-container grid-list-md text-xs-left v-if="pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
          v-for="breadcrumb in breadcrumbs"
          :key="breadcrumb.name"
          :disabled="typeof breadcrumb.link === 'undefined'"
          :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <h1 class="text-xs-left my-3 ml-3">Водители</h1>
    <v-layout row class="ml-3">
      <v-flex xs12 v-if="$store.getters.user !== null">
        <v-layout row v-if="$store.getters.user.sale_group === null">
          <v-flex xs4 lg4 md4>
            <v-menu
                ref="menu"
                :close-on-content-click="false"
                v-model="menu"
                :nudge-right="40"
                :return-value.sync="date"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
                class="mr-3"
            >
              <v-text-field
                  slot="activator"
                  v-model="dateFormatted"
                  label="Дата"
                  readonly
                  outline
              ></v-text-field>
              <v-date-picker
                  v-model="date"
                  @input="inputDate"
                  locale="ru"
                  :first-day-of-week="1"
              ></v-date-picker>
            </v-menu>
          </v-flex>

          <v-flex xs4 lg4 md4 v-if="$store.getters.user.branch === null">
            <v-select
                :items="branchTitleList"
                label="Филиал"
                v-model="branch"
                class="mr-3"
                @input="onBranchSelect()"
                outline
                no-data-text="Нет данных"
            ></v-select>
          </v-flex>

          <v-flex xs4 lg4 md4 v-if="branch !== 'Все филиалы' && branch !== null">
            <v-select
              :items="filialTitleList"
              label="Направление"
              v-model="filial"
              class="mr-3"
              @input="onFilialSelect()"
              outline
              no-data-text="Нет данных"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout row class="ml-3">
      <v-flex xs12>
        <div>
          <v-data-table
              :headers="headers"
              :items="drivers"
              :loading="loading"
              hide-actions
              class="elevation-1"
              no-data-text="Не найдено ни одного водителя"
          >
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <span slot="activator">
                  {{ props.header.text }}
                </span>
                <span>
                  {{ props.header.text }}
                </span>
              </v-tooltip>
            </template>
            <template slot="items" slot-scope="props">
              <td class="text-xs-left cursor-pointer" @click="$router.push('/drivers/single/'+date+'/'+props.item.user.id + getParamsString)">{{ props.item.user.surname }} {{ props.item.user.first_name }} {{ props.item.user.patronymic }}</td>
              <td class="text-xs-left">{{ props.item.user.filial }}</td>
              <td class="text-xs-left">{{ lastActivity(props.item.last_datetime) }}</td>
              <td class="text-xs-left">{{ indicatorFormatting(props.item.distance) === '0' ? '-' : indicatorFormatting(props.item.distance) + ' км'}}</td>
              <td class="text-xs-left">{{ indicatorFormatting(props.item.gps_distance) === '0' ? '-' : indicatorFormatting(props.item.gps_distance) + ' км'}}</td>
              <td class="text-xs-left">{{ indicatorFormatting(props.item.point_total_cnt) === '0' ? '-' : indicatorFormatting(props.item.point_total_cnt)}}</td>
              <td class="text-xs-left">{{ indicatorFormatting(props.item.point_visited_cnt) === '0' ? '-' : indicatorFormatting(props.item.point_visited_cnt)}}</td>
            </template>
          </v-data-table>
          <div class="text-xs-center pt-2">
            <v-pagination
                v-if="pages > 1"
                v-model="page"
                :length="pages"
                @input="changePage()"
                :total-visible="7"
            ></v-pagination>
          </div>
        </div>
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        breadcrumbs: [
          {name: 'Главная', link: '/'},
          {name: 'Водители'}
        ],
        pageDataReady: {
          isReady: false,
          branchList: false
        },
        date: null,
        dateFormatted: null,
        menu: false,
        branch: null,
        branchId: null,
        filial: null,
        filialId: null,
        page: 1,
        search: '',
        pagination: {},
        selected: [],
        headers: [
          { text: 'ФИО', sortable: false, value: 'name' },
          { text: 'Направление', sortable: false, value: 'filial' },
          { text: 'Последняя активность', sortable: false, value: 'last_datetime' },
          { text: 'Расчетный пробег', sortable: false, value: 'distance' },
          { text: 'Факт пробег', sortable: false, value: 'gps_distance' },
          { text: 'План ТТ', sortable: false, value: 'point_total_cnt' },
          { text: 'Посещено ТТ', sortable: false, value: 'point_visited_cnt' }
        ],
        drivers: [],
        getParamsString: ''
      }
    },
    methods: {
      pageDataStatus () {
        if (!this.pageDataReady.branchList) {
          return false
        }
        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      onBranchSelect () {
        if (this.branch !== null && this.branch !== 'Все филиалы') {
          for (let i = 0; i < this.branchList.length; i++) {
            if (this.branchList[i].title === this.branch) {
              this.branchId = this.branchList[i].id
              this.filialId = null
              break
            }
          }
          this.$store.dispatch('getFilialList', {branchId: this.branchId})
        } else {
          this.branchId = null
        }
        this.getDriverList()
        this.updateUrl()
      },
      onFilialSelect () {
        if (this.filial !== null && this.filial !== 'Все направления') {
          for (let i = 0; i < this.filialList.length; i++) {
            if (this.filialList[i].title === this.filial) {
              this.filialId = this.filialList[i].id
              break
            }
          }
        } else {
          this.filialId = null
        }
        this.getDriverList()
        this.updateUrl()
      },
      changePage () {
        this.getDriverList()
      },
      inputDate () {
        this.$refs.menu.save(this.date)
        this.dateFormatted = this.formatDate(this.date)
        this.getDriverList()
        this.updateUrl()
      },
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}.${month}.${year}`
      },
      getDriverList () {
        if (this.date !== null) {
          let data = {
            date: this.date + ' 00:00:00',
            branchId: this.branchId,
            offset: (this.page - 1) * 200,
            limit: 200,
            filialId: this.filialId
          }

          this.$store.dispatch('getDriverList', data)
        } else {
          return false
        }
      },
      convertTime (dt) {
        return dt !== null ? this.$moment(dt).format('HH:mm') : '–'
      },
      lastActivity (dateTime) {
        if (dateTime !== null && typeof dateTime !== 'undefined') {
          let sec = (Date.now() - Date.parse(dateTime.replace(/\s/, 'T'))) / 1000
          let min = sec / 60
          let hour = min / 60

          if (min < 1) {
            return '1 минуту назад'
          } else if (min < 5) {
            return Math.round(min) + ' минуты назад'
          } else if (hour < 1) {
            return Math.round(min) + ' минут назад'
          } else {
            let date = new Date(dateTime.replace(/\s/, 'T'))
            return this.convertTime(date)
          }
        } else {
          return 'Нет активности'
        }
      },
      indicatorFormatting (val) {
        val = Math.round(parseFloat(val)).toString()
        let result = ''
        let i = 0
        val.split('').reverse().forEach(function (char) {
          if (i === 3) {
            result += ' '
            i = 1
          } else {
            i++
          }
          result += char
        })
        result = result.split('').reverse().join('')
        return result
      },
      updateUrl () {
        let filter = ''
        if (this.date !== null) {
          filter += '?date=' + this.date
        }

        if (this.branchId !== null) {
          if (filter === '') {
            filter += '?branch_id=' + this.branchId
          } else {
            filter += '&branch_id=' + this.branchId
          }
        }

        if (this.filialId !== null) {
          if (filter === '') {
            filter += '?filial_id=' + this.filialId
          } else {
            filter += '&filial_id=' + this.filialId
          }
        }

        this.$router.push('/drivers/rating' + filter)
      },
      getParams () {
        let getParam = ''
        Object.keys(this.$route.query).forEach((item, i) => {
          getParam += i === 0 ? '?' + item + '=' + this.$route.query[item] : '&' + item + '=' + this.$route.query[item]
        })
        this.getParamsString = getParam
      }
    },
    computed: {
      DriverList () {
        return this.$store.getters.DriverList
      },
      branchTitleList () {
        return this.$store.getters.branchTitleList
      },
      filialTitleList () {
        return this.$store.getters.filialTitleList
      },
      branchList () {
        return this.$store.getters.branchList
      },
      filialList () {
        return this.$store.getters.filialList
      },
      loading () {
        return this.$store.getters.loading
      },
      pages () {
        let pages = this.totalCount / 200
        if ((pages ^ 0) !== pages) {
          pages = Math.floor(pages) + 1
        }
        return pages
      },
      totalCount () {
        return this.$store.getters.driverTotalCount
      }
    },
    updated () {
      this.getParams()
    },
    created () {
      this.getParams()

      this.$store.commit('setPageLoading', true)
      this.$store.commit('setPageTitle', 'Водители')
      this.$store.dispatch('getBranchList')
        .then(() => {
          this.pageDataReady.branchList = true
          this.pageDataStatus()
        })

      if (typeof this.$router.currentRoute.query.date !== 'undefined') {
        this.date = this.$router.currentRoute.query.date
      } else {
        this.date = this.$moment().format('YYYY-MM-DD')
      }
      this.dateFormatted = this.formatDate(this.date)

      if (typeof this.$router.currentRoute.query.branch_id !== 'undefined') {
        this.branchId = this.$router.currentRoute.query.branch_id
      }

      if (typeof this.$router.currentRoute.query.filial_id !== 'undefined') {
        this.filialId = this.$router.currentRoute.query.filial_id
      }

      this.getDriverList()
    },
    watch: {
      DriverList (val) {
        this.drivers = this.DriverList
      },
      branchList (val) {
        if (this.$store.getters.user.branch !== null && this.branchId === null) {
          const currentBranch = this.branchList.find(item => item.id === parseInt(this.$store.getters.user.branch.id))

          if (currentBranch) {
            this.branch = currentBranch.title
            this.branchId = currentBranch.id
            this.$store.dispatch('getFilialList', {branchId: this.branchId})
          }
        }

        if (typeof this.$router.currentRoute.query.branch_id !== 'undefined') {
          const currentBranch = this.branchList.find(item => item.id === parseInt(this.$router.currentRoute.query.branch_id))
          this.branch = currentBranch.title
          this.branchId = currentBranch.id
          this.$store.dispatch('getFilialList', {branchId: this.branchId})
        }
      },
      filialList () {
        if (this.$store.getters.user.filial_id !== null && this.filialId === null) {
          const currentFilial = this.filialList.find(item => item.id === parseInt(this.$store.getters.user.filial_id))

          if (currentFilial) {
            this.filial = currentFilial.title
            this.filialId = currentFilial.id
          }
        }

        if (typeof this.$router.currentRoute.query.filial_id !== 'undefined') {
          const currentFilial = this.filialList.find(item => item.id === parseInt(this.$router.currentRoute.query.filial_id))

          if (currentFilial) {
            this.filial = currentFilial.title
            this.filialId = currentFilial.id
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Drivers/DriverRating.vue